export default __webpack_public_path__ + "static/media/car-park-highlight.1dcd1ae0.svg";